var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',[_c('CRow',[_c('h6',[_vm._v(" En este módulo podrá realizar un Pedido realizando busqueda entre el catálogo de productos asignados al cliente. ")])]),_c('ImageGallery',{attrs:{"cartMode":true,"data":_vm.products}}),(_vm.loading)?_c('CElementCover'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }